/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListSlackDirectoryMembersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Filter mapping state.
 */
export const MappingStatus = {
  Unmapped: "unmapped",
  Mapped: "mapped",
  NeedsReview: "needs_review",
} as const;
/**
 * Filter mapping state.
 */
export type MappingStatus = ClosedEnum<typeof MappingStatus>;

export type ListSlackDirectoryMembersRequest = {
  /**
   * Filter to a workspace connection.
   */
  connectionId?: string | undefined;
  /**
   * Literal case-insensitive name, email or Slack ID search.
   */
  search?: string | undefined;
  /**
   * Filter mapping state.
   */
  mappingStatus?: MappingStatus | undefined;
  /**
   * Include members deactivated in Slack.
   */
  includeDeactivated?: boolean | undefined;
  /**
   * Include bots and apps.
   */
  includeBots?: boolean | undefined;
  /**
   * Include guests.
   */
  includeGuests?: boolean | undefined;
  /**
   * Sort by mapping state at this time, so mapping changes after it do not reorder pages. Pass back the sort_as_of from the first page; defaults to the database's current time.
   */
  sortAsOf?: Date | undefined;
  /**
   * One-based page number. Unmapped members sort first, then members needing review, then mapped members, each alphabetically.
   */
  page?: number | undefined;
  /**
   * Maximum returned rows.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListSlackDirectoryMembersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSlackDirectoryMembersSecurity$outboundSchema: z.ZodMiniType<
  ListSlackDirectoryMembersSecurity$Outbound,
  ListSlackDirectoryMembersSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSlackDirectoryMembersSecurityToJSON(
  listSlackDirectoryMembersSecurity: ListSlackDirectoryMembersSecurity,
): string {
  return JSON.stringify(
    ListSlackDirectoryMembersSecurity$outboundSchema.parse(
      listSlackDirectoryMembersSecurity,
    ),
  );
}

/** @internal */
export const MappingStatus$outboundSchema: z.ZodMiniEnum<typeof MappingStatus> =
  z.enum(MappingStatus);

/** @internal */
export type ListSlackDirectoryMembersRequest$Outbound = {
  connection_id?: string | undefined;
  search?: string | undefined;
  mapping_status?: string | undefined;
  include_deactivated: boolean;
  include_bots: boolean;
  include_guests: boolean;
  sort_as_of?: string | undefined;
  page: number;
  limit: number;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSlackDirectoryMembersRequest$outboundSchema: z.ZodMiniType<
  ListSlackDirectoryMembersRequest$Outbound,
  ListSlackDirectoryMembersRequest
> = z.pipe(
  z.object({
    connectionId: z.optional(z.string()),
    search: z.optional(z.string()),
    mappingStatus: z.optional(MappingStatus$outboundSchema),
    includeDeactivated: z._default(z.boolean(), false),
    includeBots: z._default(z.boolean(), false),
    includeGuests: z._default(z.boolean(), false),
    sortAsOf: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    page: z._default(z.int(), 1),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      connectionId: "connection_id",
      mappingStatus: "mapping_status",
      includeDeactivated: "include_deactivated",
      includeBots: "include_bots",
      includeGuests: "include_guests",
      sortAsOf: "sort_as_of",
      gramSession: "Gram-Session",
    });
  }),
);

export function listSlackDirectoryMembersRequestToJSON(
  listSlackDirectoryMembersRequest: ListSlackDirectoryMembersRequest,
): string {
  return JSON.stringify(
    ListSlackDirectoryMembersRequest$outboundSchema.parse(
      listSlackDirectoryMembersRequest,
    ),
  );
}
